"use client"

import React from "react";

export default function ThemeModifier({siteConfig}){
    React.useEffect(() => {
        if (siteConfig?.themeConfig) {
            for (let [key, value] of Object.entries(siteConfig.themeConfig)) {
                //console.log(`Override theme config ${key} -> ${value}`)
                document.documentElement.style.setProperty(`--${key}`, value);
            }
        }
    }, [siteConfig])
}